var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAleo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8855_2851)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 -0.000732422C18.6262 -0.000732422 23.9992 5.37227 23.9992 11.9985C23.9992 18.6248 18.6262 24 12 24C5.37373 24 0.000732422 18.627 0.000732422 12.0008C0.000732422 5.37452 5.37373 -0.000732422 12 -0.000732422Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.499268C18.3501 0.499268 23.4992 5.64841 23.4992 11.9985C23.4992 18.3487 18.35 23.5 12 23.5C5.64987 23.5 0.500732 18.3509 0.500732 12.0008C0.500732 5.65054 5.64999 0.499268 12 0.499268Z",
    stroke: "#5B616E",
    strokeOpacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6712 4.875H10.5559L7.85141 12.7674H6.21938L5.72119 14.2211H7.35322L5.92992 18.375H7.57256L8.98871 14.2211H15.163L16.5789 18.375H18.2783L13.6712 4.875ZM9.49843 12.7674L8.98871 14.2211H7.35322L7.85141 12.7674H9.49843ZM9.49843 12.7674L11.6888 6.32874H12.4818L14.672 12.7674H9.49843Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8855_2851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAleo);
export default __webpack_public_path__ + "static/media/aleo.27b294bb0effcbdac34fb7b4ad4b4f46.svg";
export { ForwardRef as ReactComponent };